
import { useEffect, useState } from "react";
import { _EcmDocument, _QualityInspectionChangePartsItems, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { SelectTHConstantsValue } from "../../../../../bpm/config/Componentes/SelectTHConstantsValue";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectQualityGarment } from "../../../QualityGarment/SelectQualityGarment";
import { SelectQualityGarmentPiece } from "../../../QualityGarment/QualityGarmentPiece/SelectQualityGarmentPiece";
import { ProductionOrderEditor } from "../../../../ProductionOrder/ProductionOrderEditor";
import { SingPanelEditor } from "../../../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { PdfDocuments } from "../../../../../documents/PdfDocuments";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ExportXLSL } from "../../../../../theme/Component/ExportXLSX";
import { DropDown } from "../../../../../theme/Component/DropDown";
import { ImportXLSX } from "../../../../../theme/Component/ImportXLSX";

interface componentData {
    QualityInspectionChangeParts: any;
    isReport?: boolean;
}

interface formData {
    Year: number;
    FromDate: any;
    UptoDate: any;
    ProductionOrder: number;
    ProductionOrderDate: any;
    NoIdentification: string;
    IDGarment: number;
    IDGarmentPiece: number;
    IDDefect: number;
}

export const QualityInspectionChangePartsItems = ({ QualityInspectionChangeParts, isReport }: componentData) => {
    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityInspectionChangePartsItems);
    const paginator = usePaginator();
    const signed = useDataBean(_EcmDocument);

    const [form, setForm] = useState<Partial<formData>>({});
    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);
    const modalDocument = useModal("Solicitar flujo de firmas", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);
    const modalImport = useModal("Importar Reprocesos", MODAL_md);

    // Helpers para vigencia
    const getYear = (d: any) => (d ? new Date(d).getFullYear() : undefined);
    const fixedYear = QualityInspectionChangeParts?.Since
        ? new Date(QualityInspectionChangeParts.Since).getFullYear()
        : undefined;

    const head = [
        { title: "ID", property: "IDQualityInspectionChangePartsItems", visible: true },
        { title: "Fecha de Solicitud", property: "RequestDate", visible: true },
        { title: "Orden de Producción", property: "EntityOrder", visible: true },
        { title: "Talla", property: "VariantName", visible: true },
        { title: "Lote", property: "Lot", visible: true },
        { title: "Numero de Identificación", property: "IdentificationNumber", visible: true },
        { title: "Prenda", property: "GarmentName", visible: true },
        { title: "Pieza", property: "EntityPiece", visible: true },
        { title: "Cantidad", property: "Quantity", visible: true },
        { title: "Defecto", property: "DefectName", visible: true },
    ];

    useEffect(() => {
        if (QualityInspectionChangeParts?.IDQualityInspectionChangeParts) {
            getLista();
        } else if (isReport) {
            getLista();
        }
    }, [QualityInspectionChangeParts?.IDQualityInspectionChangeParts, paginator.page]);

    const getLista = () => {
        const fromY = getYear(form.FromDate);
        const uptoY = getYear(form.UptoDate);

        if (fixedYear) {
            if ((fromY && fromY !== fixedYear) || (uptoY && uptoY !== fixedYear)) {
                toast.error(`Las fechas deben pertenecer a la vigencia ${fixedYear}`);
                return;
            }
        }
        if (fromY && !uptoY || !fromY && uptoY) {
            toast.error("Debe seleccionar fecha desde y hasta");
            return;
        }


        if (fromY && uptoY && fromY !== uptoY) {
            toast.error("Las fechas deben estar en la misma vigencia");
            return;
        }

        const props: any = {
            IDQualityInspectionChangeParts: QualityInspectionChangeParts?.IDQualityInspectionChangeParts,
            State: 1,
        };

        if (form.IDGarment) props.IDQualityGarment = form.IDGarment;
        if (form.IDGarmentPiece) props.IDQualityGarmentPiece = form.IDGarmentPiece;
        if (form.IDDefect) props.IDDefect = form.IDDefect;
        if (form.NoIdentification) props.IdentificationNumber = form.NoIdentification;
        if (form.ProductionOrder) props.IDProductionOrder = form.ProductionOrder;

        instance
            .getQualityInspectionChangePartsItemsRender(paginator.page, 15, props, form.FromDate, form.UptoDate)
            .then((resp) => {
                resp.List.forEach((element) => {
                    const data = element.DataBeanProperties;
                    data.EntityPiece = data.IDQualityGarmentPiece ? `${data.PieceCode ?? ""} - ${data.PieceName ?? ""}` : "N/A";
                    data.EntityOrder = data.IDProductionOrder ? `${data.IDProductionOrder ?? ""} - ${data.ProductionOrderDate ?? ""}` : "N/A";
                });
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List);
            })
            .catch((err) => {
                toast.error(err);
            });
    };

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            IDQualityInspectionChangeParts: QualityInspectionChangeParts?.IDQualityInspectionChangeParts,
            IDProductionOrder: QualityInspectionChangeParts?.IDProductionOrder,
            IDProductVariant: QualityInspectionChangeParts?.IDProductVariant,
            State: 1,
            IDEmployee: _single.getAccountID(),
            RequestDate: _single.getCurrenDate(),
        });
        modal.open("Agregar Norma o Especificación");
    };

    const iconButtonsItem = [
        { nombre: "Agregar", visible: _single.canCreate() && !isReport, icono: "ri-file-add-line", evento: create },
        { nombre: 'Importar', visible: _single.canCreate() && (!isReport), icono: 'ri-file-upload-line', evento: () => { modalImport.open(); } }
    ];

    const listaBotones = () => {
        const botones = [
            { titulo: "Editar", icono: "ri-edit-2-line", visible: _single.canEdit() && !isReport, evento: () => modal.open("Editar Norma o Especificación") },
            { titulo: "Solicitar Aprobaciones", icono: "mdi mdi-signature-text", visible: _single.canEdit(), evento: () => modalDocument.open() },
            { titulo: "Ver Documento", icono: "mdi mdi-folder-eye-outline", visible: bean.IDDocument, evento: () => modalSeeDocument.open() },
            { titulo: "Eliminar", icono: "ri-delete-bin-line", visible: _single.canDelete() && !isReport, evento: () => modalC.open() },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    };

    const editaItem = (obj: any) => {
        instance
            .updateQualityInspectionChangePartsItems(obj)
            .then(() => {
                getLista();
                modal.close();
                modalC.close();
                modalDocument.close();
            })
            .catch((err) => {
                toast.error(err);
            });
    };

    const validateForm = () => {
        const requiredFields = ["RequestDate", "Lot", "IdentificationNumber", "IDQualityGarment", "IDQualityGarmentPiece", "Quantity", "IDDefect"];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const validateDataSigned = () => {
        if (!signed.bean.IDSignPanel) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createEcmDocumentForFlowControl();
        }
    };

    const createEcmDocumentForFlowControl = () => {
        const Obs = `Cambio de Piezas`;

        signed.instance
            .createEcmDocumentForFlowControl(signed.bean.IDSignPanel, _single.getAccountID(), Obs, null, null, null, _single.getAccountID())
            .then((resp: any) => {
                if (resp.IDDocument > 0) {
                    signed.instance
                        .fireSigningDocumentFlow(resp.IDDocument, resp.Mnemonic, resp.DocumentDate, signed.bean.IDSignPanel, _single.getAccountID())
                        .then((resp: any) => {
                            toast.success(resp);
                        })
                        .catch(() => {
                            toast.error("No se pudo iniciar proceso de firmas");
                        });
                    editaItem({ ...bean, IDDocument: resp.IDDocument, DocumentDate: resp.DocumentDate });
                } else {
                    toast.error("No se genero documentoa firmar");
                }
            })
            .catch((err) => {
                toast.error(err);
            });
    };

    const modalGraph = useModal("Reporte Excel", MODAL_SM);
    const [listaExport, setListaExport] = useState<any[]>([]);

    const getListaExport = () => {
        const fromY = getYear(form.FromDate);
        const uptoY = getYear(form.UptoDate);

        if (fixedYear) {
            if ((fromY && fromY !== fixedYear) || (uptoY && uptoY !== fixedYear)) {
                toast.error(`Las fechas deben pertenecer a la vigencia ${fixedYear}`);
                return;
            }
        }
        if (fromY && !uptoY || !fromY && uptoY) {
            toast.error("Debe seleccionar fecha desde y hasta");
            return;
        }


        if (fromY && uptoY && fromY !== uptoY) {
            toast.error("Las fechas deben estar en la misma vigencia");
            return;
        }

        const props: any = {
            IDQualityInspectionChangeParts: QualityInspectionChangeParts?.IDQualityInspectionChangeParts,
            State: 1,
        };

        if (form.IDGarment) props.IDQualityGarment = form.IDGarment;
        if (form.IDGarmentPiece) props.IDQualityGarmentPiece = form.IDGarmentPiece;
        if (form.IDDefect) props.IDDefect = form.IDDefect;
        if (form.NoIdentification) props.IdentificationNumber = form.NoIdentification;
        if (form.ProductionOrder) props.IDProductionOrder = form.ProductionOrder;

        instance
            .getQualityInspectionChangePartsItemsRender(1, paginator.pages * 15,  props, form.FromDate, form.UptoDate)
            .then((resp) => {
                resp.List.forEach((element) => {
                    const data = element.DataBeanProperties;
                    data.EntityPiece = data.IDQualityGarmentPiece ? `${data.PieceCode ?? ""} - ${data.PieceName ?? ""}` : "N/A";
                    data.EntityOrder = data.IDProductionOrder ? `${data.IDProductionOrder ?? ""} - ${data.ProductionOrderDate ?? ""}` : "N/A";
                });
                modalGraph.open();
                setListaExport(resp.List);
            })
            .catch((err) => {
                toast.error(err);
            });
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Excel', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaExport();
                        }
                    }} />
                </div>
            </div>
        )
    }

    const [data, setData] = useState<string>('');


    const importData = () => {

        const yearOrder = _single.getCurrenYear();

        instance.importChangePartItems(_single.getAccountID(), JSON.stringify(data), QualityInspectionChangeParts?.IDQualityInspectionChangeParts, yearOrder).then(
            (resp: any) => {
                getLista();
                modalImport.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    return (
        <div className="row">
            <div className="col-md-4">
                <InputDate name="" value={form.FromDate} label="Fecha desde" setDate={(e) => { setForm({ ...form, FromDate: e }) }} />
            </div>
            <div className="col-md-4">
                <InputDate name="" value={form.UptoDate} label="Fecha hasta" setDate={(e) => { setForm({ ...form, UptoDate: e }) }} />
            </div>
            <div className="col-md-4">
                <ProductionOrderEditor IDOrderProduction={form.ProductionOrder} returnData={(e) => { setForm({ ...form, ProductionOrder: e.IDProductionOrder, ProductionOrderDate: e.IDProductionOrderDate }) }} />
            </div>
            <div className="col-md-4">
                <label>No Identificación</label>
                <input type="text" value={form.NoIdentification} onChange={(e) => { setForm({ ...form, NoIdentification: e.target.value }) }} className="form-control" />
            </div>
            <div className="col-md-4">
                <SelectQualityGarment idSelector={form.IDGarment} onChange={(e) => { setForm({ ...form, IDGarment: e }) }} label="Prenda" />
            </div>

            {form.IDGarment &&
                <div className="col-md-4">
                    <SelectQualityGarmentPiece _idQualityGarment={form.IDGarment} idSelector={form.IDGarmentPiece} onChange={(e) => { setForm({ ...form, IDGarmentPiece: e }) }} label="Pieza de Prenda" />
                </div>
            }

            <div className="col-md-4">
                <SelectTHConstantsValue label="Defecto" code={912} onChange={(e) => { setForm({ ...form, IDDefect: e }) }} value={form.IDDefect} />
            </div>

            <div className="col-md-3">
                <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" useMargin children={`Buscar`} />
            </div>
            <div className="col-md-12">
                <BasicTable
                    headButtons={buttons()}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    pageTop={paginator.page}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('RequestDate') ? 'has-error' : ''}`}>Fecha de Solicitud</label>
                            <InputDate name="" value={bean.RequestDate} setDate={(e) => { setBean({ ...bean, RequestDate: e }) }} />
                        </div>
                        {!QualityInspectionChangeParts?.IDProductionOrder &&
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('RequestDate') ? 'has-error' : ''}`}>Orden de Producción</label>
                                <ProductionOrderEditor ConfigProps={{ label: " " }} IDOrderProduction={bean.IDProductionOrder} returnData={(e) => { setBean({ ...bean, IDProductionOrder: e.IDProductionOrder, IDProductVariant: e.IDProductVariant }) }} _renderValue="" />
                            </div>
                        }

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('RequestDate') ? 'has-error' : ''}`}>Lote</label>
                            <input type="text" value={bean.Lot} onChange={(e) => { setBean({ ...bean, Lot: e.target.value }) }} className="form-control" />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IdentificationNumber') ? 'has-error' : ''}`}>Numero de la Pieza</label>
                            <input type="text" value={bean.IdentificationNumber} onChange={(e) => { setBean({ ...bean, IdentificationNumber: e.target.value }) }} className="form-control" />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDQualityGarment') ? 'has-error' : ''}`}>Prenda</label>
                            <SelectQualityGarment idSelector={bean.IDQualityGarment} onChange={(e) => { setBean({ ...bean, IDQualityGarment: e }) }} label=" " />
                        </div>

                        {bean.IDQualityGarment &&
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDQualityGarmentPiece') ? 'has-error' : ''}`}>Pieza de Prenda</label>
                                <SelectQualityGarmentPiece _idQualityGarment={bean.IDQualityGarment} idSelector={bean.IDQualityGarmentPiece} onChange={(e) => { setBean({ ...bean, IDQualityGarmentPiece: e }) }} label=" " />
                            </div>
                        }

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                            <input
                                type="number"
                                value={bean.Quantity}
                                onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null
                                    setBean({ ...bean, Quantity: value })
                                }}
                                className="form-control"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDDefect') ? 'has-error' : ''}`} >Defecto</label>
                            <SelectTHConstantsValue label=" " code={912} onChange={(e) => { setBean({ ...bean, IDDefect: e }) }} value={bean.IDDefect} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('DeliveryDate') ? 'has-error' : ''}`}>Fecha de Entrega</label>
                            <InputDate name="" value={bean.DeliveryDate} setDate={(e) => { setBean({ ...bean, DeliveryDate: e }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                    <div className="row">
                        <div className="col">
                            {lista.length > 0 &&
                                <ExportXLSL customName={"Cambios"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { validateDataSigned() }}  >
                    <div className="col-md-12">
                        <label className={`${missingFields.includes('IDSignPanel') ? 'has-error' : ''}`}>Panel de Firma</label>
                        <SingPanelEditor idSelector={signed.bean.IDSignPanel} label=" " onChange={(e) => { signed.setBean({ ...signed.bean, "IDSignPanel": e }) }} />
                    </div>
                </Modal>

                <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                    <PdfDocuments documentLocation={bean.IDDocument} date={bean.DocumentDate} mnemonic="ECM" />
                </Modal>

                <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={() => { importData() }}  >
                    <ImportXLSX lodaData={setData} />
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}